export const clearPendoIdentify = () => {
	if ((window as any).pendo) {
		try {
			(window as any).pendo.clearSession();
		} catch (error) {
			console.error('Error clearing Pendo session', error);
		}
	}
}
